// no itx for this file
import { firstChildWithAtribute } from "../components/XmlUtils";

export default class KnxLanguageMappingXml {
  mapping = new Map<string, any>();

  load(Languages: any) {
    for (let l in Languages.items) {
      const languageId = Languages.items[l].a.Identifier;
      const language = firstChildWithAtribute(Languages, "Identifier", languageId);
      for (let k in language.items) {
        const TranslationUnit = language.items[k];
        for (let i in TranslationUnit.items) {
          const translationElement = TranslationUnit.items[i];
          const translationItems: any = {};
          for (let j in translationElement.items) {
            const item = translationElement.items[j];
            const name: string = item.a.AttributeName as string;
            translationItems[name] = item.a.Text;
          }
          this.mapping.set(
            translationElement.a.RefId,
            (this.mapping.get(translationElement.a.RefId) || new Map<string, any>()).set(languageId, translationItems),
          );
        }
      }
    }
  }

  getTranslation(id: string | undefined): string | undefined {
    let item;
    if (id == "") {
      item = this.mapping.get(id);
    } else if (id) {
      const idx = id.indexOf("_R-");
      if (idx > 0) {
        id = id.substring(0, idx);
      }
      item = this.mapping.get(id);
    }
    return item;
  }
}
